import { request } from "../http/api-client";

const BASE = (typeof import.meta !== "undefined" && (import.meta as any).env?.VITE_PAYOUTS_BASE_URL) || "http://localhost:3099";
const API_BASE = (typeof import.meta !== "undefined" && (import.meta as any).env?.VITE_API_BASE_URL) || "https://api.paygate.sbs";

export async function createPayout(payload: {
  amount: number;
  currency: "INR" | "USDT";
  purpose: string;
  mode: string;
  reference?: string;
  notes?: string;
  beneficiary: Record<string, any>;
}) {
  const url = `${BASE}/api/v1/payouts`;
  const idempotency = crypto?.randomUUID?.() || `idemp_${Date.now()}`;
  const res = await request<{ success: boolean; data: any }>(url, {
    method: "POST",
    headers: { "X-Idempotency-Key": idempotency },
    body: payload,
  });
  return res.data;
}

export async function listBeneficiaries(params?: { page?: number; limit?: number }) {
  const search = new URLSearchParams();
  if (params?.page) search.set("page", String(params.page));
  if (params?.limit) search.set("limit", String(params.limit));
  const url = `${BASE}/api/v1/payouts/beneficiaries${search.toString() ? `?${search.toString()}` : ""}`;
  const res = await request<{ success: boolean; data: any[]; pagination?: any }>(url, {
    method: "GET",
  });
  return res.data;
}

export async function createBeneficiary(payload: {
  name: string;
  type: "individual" | "business";
  email?: string | null;
  phone?: string | null;
  accountDetails: {
    accountHolderName: string;
    accountNumber: string;
    ifscCode: string;
    bankName: string;
    accountType: string;
  };
  address?: {
    line1?: string;
    city?: string;
    state?: string;
    country?: string;
    postalCode?: string;
  } | null;
}) {
  const url = `${BASE}/api/v1/payouts/beneficiaries`;
  const res = await request<{ success: boolean; data: any }>(url, {
    method: "POST",
    body: payload,
  });
  return res.data;
}

export async function listPayouts(filters: {
  page?: number;
  limit?: number;
  status?: string[];
  dateFrom?: string;
  dateTo?: string;
}) {
  const search = new URLSearchParams();
  if (filters.page) search.set("page", String(filters.page));
  if (filters.limit) search.set("limit", String(filters.limit));
  if (filters.status?.length) search.set("status", filters.status.join(","));
  if (filters.dateFrom) search.set("dateFrom", filters.dateFrom);
  if (filters.dateTo) search.set("dateTo", filters.dateTo);
  const res = await request<{ success: boolean; data: any[]; pagination: any }>(`/api/v1/payouts?${search.toString()}`);
  return res;
}

export async function getWallets() {
  const res = await request<{ success: boolean; data: any[]; pagination?: any }>(`/api/v1/wallets`);
  return res.data;
}

export async function getMerchantFees(merchantId: string) {
  const res = await request<{ success: boolean; data: any }>(`/api/v1/merchants/${merchantId}/fees`);
  return res.data;
}
